import { spliceDeleteSQLByConditions } from '../_utils/deleteSQL';
export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val) {
        var _a;
        var isEdit = (_a = env.runtime) === null || _a === void 0 ? void 0 : _a.debug;
        if (data.rules) {
            try {
                env.collect('删除数据 val: ', val);
                var sql = spliceDeleteSQLByConditions({
                    conditions: data.rules.conditions,
                    entities: data.rules.entities,
                    params: val,
                    isEdit: isEdit,
                });
                env.collect('删除数据 sql: ', sql);
                env.executeSql(sql)
                    .then(function () { return outputs['rtn'](); })
                    .catch(function (ex) { return onError("\u6267\u884CSQL\u53D1\u751F\u9519\u8BEF,".concat(ex === null || ex === void 0 ? void 0 : ex.message)); });
            }
            catch (error) {
                isEdit ? console.error('执行SQL发生错误, ', error) : undefined;
                onError("\u6267\u884C\u9519\u8BEF, ".concat(error === null || error === void 0 ? void 0 : error.message));
            }
        }
    });
}
